<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
            @ok="copyTe"
        >
            <template #modal-title>
                Copy TE
            </template>

            <b-form-group
                label="Publication"
                for="publication"
            >
                <multiselect
                    v-model="publication"
                    :options="publications"
                    label="title"
                    track-by="title"
                />
                <b-form-text>
                    Select the publication you would like to copy the TE from
                </b-form-text>
            </b-form-group>

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    <span v-if="publication_selected">Cancel</span><span v-else>Close</span>
                </b-button>
                <b-button
                    v-if="publication_selected"
                    variant="secondary"
                    @click="copyTe"
                >
                    <font-awesome-icon :icon="['fad', 'copy']" fixed-width /> Copy TE
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        publication: {}
    }),
    props: [
        'value'
    ],
    components: {

    },
    computed: {
        ...mapState({
            publications: state => state.publications.publications
        }),
        modal_id () {
            let modal_id = 'autofill-te-modal'
            return modal_id
        },
        publication_selected () {
            let selected = false

            if (_.some(this.publication)) {
                selected = true
            }

            return selected
        }
    },
    watch: {
        value: {
            handler (value) {
                if (value == true) {
                    this.publication = {}
                    this.getPublications()
                }
            }
        }
    },
    methods: {
        getPublications () {
            this.$store.dispatch('getPublications')
        },
        copyTe () {
            this.$emit('copy', this.publication)
        },
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {
            this.publication = {}

            this.$emit('hide')
        }
    }
}
</script>
